exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".thumbnail.widget {\n    display: flex;\n    width: 48px;\n    max-width: 48px;\n    min-width: 48px;\n    padding: 0;\n    margin: 0;\n    border-radius: 0;\n    flex: 0;\n    background: none;\n\n}\n.thumbnail.widget img{\n    max-width: 100%;\n    min-width: 100%;\n    pointer-events: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/widget/thumbnail/index.css
// module id = 520
// module chunks = 0